var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Associated"},[_c('NewForm',{attrs:{"data":_vm.formData}}),(_vm.associatShow)?_c('ChooseAssociated'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }